"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processNumeric = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _input = require("../../input");
var _tooltip = require("../../tooltip");
var _misc = require("../../misc");
var _SearchableDEPRECATED = _interopRequireDefault(require("./Searchable.DEPRECATED.style"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _PercentageToggler = _interopRequireDefault(require("./PercentageToggler"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NUMERIC_CUTOFF = 12;
var processNumeric = exports.processNumeric = function processNumeric(value) {
  if (!value) return '';
  var processed = value.replace(/^0{1,}/, '') || '0';
  return processed.indexOf('.') === 0 ? "0".concat(processed) : processed;
};
var handleScrollableDropdown = function handleScrollableDropdown(currentIndex) {
  var items = window.document.querySelectorAll('.list-menu-items');
  var itemsWrapper = window.document.querySelector('.list-menu-wrapper');
  if (!items.length) return;
  var elHeight = items[currentIndex].clientHeight;
  var wrapperScrollTop = itemsWrapper.scrollTop;
  var viewport = wrapperScrollTop + itemsWrapper.clientHeight;
  var elOffset = elHeight * currentIndex;
  if (elOffset < wrapperScrollTop || elOffset + elHeight > viewport) {
    itemsWrapper.scrollTop = elOffset;
  }
};
var Searchable = /*#__PURE__*/function (_React$PureComponent) {
  function Searchable(props) {
    var _this;
    _classCallCheck(this, Searchable);
    _this = _callSuper(this, Searchable, [props]);
    _defineProperty(_this, "onChange", function (value) {
      var computedSearchValue;
      var regexPattern = _this.props.regexPattern;
      var isLetter = _this.props.employeeSearchable ? true : /[a-zA-Z]+/.test(value);
      if (regexPattern) {
        computedSearchValue = regexPattern.test(_this.state.searchValue + value) ? _this.state.searchValue + value : (_this.state.searchValue + value).slice(0, -1);
      } else {
        computedSearchValue = _this.state.searchValue + value;
      }
      var isNumeric = _this.props.employeeSearchable ? false : /^([0-9]*\.?[0-9]*|[0-9]*\.?|\.?[0-9]*)$/.test(computedSearchValue);
      if ((_this.props.numericOnly || _this.props.percentageOnly) && !isNumeric) return false;
      if (!_this.state.searchValue && isNumeric || _this.state.isNumeric) {
        if (!isNumeric) return false;
        var searchValue = processNumeric(computedSearchValue);
        _this.setState({
          isNumeric: true,
          searchValue: searchValue
        });
        _this.props.formulaChange({
          value: searchValue,
          type: _this.props.type === 'percentage' ? 'percentage' : 'numeric'
        });
        return false;
      }
      if (_this.state.searchValue || isLetter) {
        if (_this.state.emptyResults) {
          return false;
        }
        var _searchValue = computedSearchValue;
        _this.setState({
          searchValue: _searchValue,
          searchingResults: true,
          emptyResults: false
        });
        _this.autoCompleteVariables(_searchValue);
      }
      return false;
    });
    _defineProperty(_this, "handleClickOutside", function () {
      _this.setState({
        searchValue: '',
        showResultsDropdown: false,
        emptyResults: false,
        searchingResults: false
      });
    });
    _defineProperty(_this, "handleItemSelect", function (event, currentIndex) {
      if (_this.state.searchValue && _this.state.list.length) {
        var selectedItem = _this.state.list[currentIndex];
        _this.setState({
          searchValue: '',
          showResultsDropdown: false,
          list: []
        });
        if (!_this.props.employeeSearchable) {
          _this.props.formulaChange({
            value: "".concat(selectedItem.dataSource, ".").concat(selectedItem.value),
            description: selectedItem.description,
            dataSource: selectedItem.dataSource,
            type: 'variable',
            displayName: selectedItem.displayName
          });
        } else {
          _this.props.formulaChange(selectedItem);
        }
      }
      event.preventDefault();
    });
    _defineProperty(_this, "itemClick", function (item) {
      _this.setState({
        list: [],
        searchValue: '',
        showResultsDropdown: false
      });
      if (!_this.props.employeeSearchable) {
        _this.props.formulaChange({
          value: "".concat(item.dataSource, ".").concat(item.value),
          description: item.description,
          dataSource: item.dataSource,
          type: 'variable',
          displayName: item.displayName
        });
      } else {
        _this.props.formulaChange(item);
      }
    });
    _defineProperty(_this, "handleKeyPress", function (event) {
      var currentIndex = _this.state.selectedListIndex;
      var isNumeric = _this.state.isNumeric;
      switch (event.key) {
        case 'Backspace':
          {
            if (!isNumeric && _this.state.searchValue) {
              var searchValue = _this.state.searchValue.slice(0, -1);
              _this.setState({
                searchValue: searchValue,
                searchingResults: searchValue,
                emptyResults: false,
                showResultsDropdown: false
              });
              _this.autoCompleteVariables(searchValue);
              return;
            }
            _this.setState({
              searchValue: '',
              showResultsDropdown: false,
              list: [],
              isNumeric: false
            });
            if (!_this.props.employeeSearchable) {
              _this.props.formulaChange({
                value: '',
                description: '',
                dataSource: '',
                type: 'variable'
              });
            } else {
              _this.props.formulaChange({
                employeeId: '',
                employeeName: '',
                country: '',
                email: ''
              });
            }
            break;
          }
        case 'Delete':
          _this.setState({
            searchValue: '',
            showResultsDropdown: false,
            list: [],
            isNumeric: false
          });
          if (!_this.props.employeeSearchable) {
            _this.props.formulaChange({
              value: '',
              description: '',
              dataSource: '',
              type: 'variable'
            });
          } else {
            _this.props.formulaChange({
              employeeId: '',
              employeeName: '',
              country: '',
              email: ''
            });
          }
          break;
        case 'Escape':
          _this.setState({
            searchValue: '',
            emptyResults: false,
            showResultsDropdown: false
          });
          break;
        case 'Tab':
          if (!isNumeric) _this.handleItemSelect(event, currentIndex);
          break;
        case 'Enter':
          if (!isNumeric) _this.handleItemSelect(event, currentIndex);
          break;
        case 'ArrowDown':
          currentIndex = currentIndex + 1 > _this.state.list.length - 1 ? 0 : currentIndex + 1;
          _this.setState({
            selectedListIndex: currentIndex
          });
          if (_this.props.employeeSearchable) {
            handleScrollableDropdown(currentIndex);
          }
          break;
        case 'ArrowUp':
          currentIndex = currentIndex - 1 < 0 ? _this.state.list.length - 1 : currentIndex - 1;
          _this.setState({
            selectedListIndex: currentIndex
          });
          if (_this.props.employeeSearchable) {
            handleScrollableDropdown(currentIndex);
          }
          break;
        default:
          break;
      }
    });
    _defineProperty(_this, "handlingSearchableAction", function (searchValue) {
      _this.props.searchableAction(searchValue).then(function (data) {
        if (data && data.length) {
          _this.setState({
            list: _this.props.employeeSearchable ? data : data.slice(0, 10),
            showResultsDropdown: true,
            emptyResults: false,
            selectedListIndex: 0,
            searchingResults: false
          });
        } else {
          _this.setState({
            list: [],
            searchingResults: false,
            showResultsDropdown: false,
            emptyResults: _this.state.searchValue,
            selectedListIndex: 0
          });
        }
      });
    });
    _defineProperty(_this, "autoCompleteVariables", (0, _utils.debounce)(function (searchValue) {
      return _this.props.employeeSearchable ? searchValue.length >= 3 && _this.handlingSearchableAction(searchValue) : _this.handlingSearchableAction(searchValue);
    }, 300));
    _defineProperty(_this, "renderSearchableComponent", function (_ref) {
      var value = _ref.value,
        _ref$searchValue = _ref.searchValue,
        searchValue = _ref$searchValue === void 0 ? value : _ref$searchValue;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "formula-search-value ".concat(searchValue.length > NUMERIC_CUTOFF && !_this.props.employeeSearchable ? 'formula-direction-rtl' : ''),
        dangerouslySetInnerHTML: {
          __html: searchValue.replace(/\s/g, '&nbsp;')
        }
      }), /*#__PURE__*/_react["default"].createElement(_input.Input, {
        onKeyDown: _this.handleKeyPress,
        required: true,
        className: "rule-formula ".concat(searchValue || value ? 'no-placeholder' : ''),
        name: _this.props.id,
        id: _this.props.id || "rule-".concat(_this.props.ruleIndex, "-formula-input-").concat(_this.props.keysPath.join('-')),
        value: "",
        onChange: function onChange(event) {
          event.persist();
          _this.onChange(event.target.value);
        },
        icon: _this.props.searchIcon ? 'ion-android-search' : undefined,
        placeholder: searchValue || value ? '' : _this.props.placeholder || _this.props.labels.FORMULA_INPUT_PLACEHOLDER
      }), _this.props.type === 'percentage' && !_this.props.isFocused ? value && /*#__PURE__*/_react["default"].createElement("span", {
        className: "searchable-percentage"
      }, "%") : '', _this.state.isNumeric && _this.props.isFocused && /*#__PURE__*/_react["default"].createElement(_PercentageToggler["default"], {
        percentageOnly: _this.props.percentageOnly,
        numericOnly: _this.props.numericOnly,
        formulaChange: _this.props.formulaChange,
        type: _this.props.type,
        value: searchValue || value
      }));
    });
    _defineProperty(_this, "renderDropdown", function () {
      if (_this.state.showResultsDropdown) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this.listRef
        }, /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu"
        }, /*#__PURE__*/_react["default"].createElement("ul", null, _this.state.list.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: item.description.toString()
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: index === _this.state.selectedListIndex ? 'selected' : '',
            onMouseDown: function onMouseDown() {
              return _this.itemClick(item);
            }
          }, item.description));
        }))));
      }
      if (_this.state.searchingResults) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu searching-menu"
        }, _this.props.labels.SEARCHING_LABEL);
      }
      if (_this.state.emptyResults) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu empty-results-menu"
        }, _this.props.labels.NO_RESULTS_FOUND_LABEL);
      }
      return false;
    });
    _defineProperty(_this, "renderEmployeesDropdown", function () {
      var extraInfo = _this.props.extraInfo;
      if (_this.state.showResultsDropdown && _this.state.searchValue.length >= 3) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu"
        }, /*#__PURE__*/_react["default"].createElement("ul", {
          className: "list-menu-wrapper"
        }, _this.state.list.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: item.employeeId.toString(),
            className: "list-menu-items"
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: index === _this.state.selectedListIndex ? 'selected' : '',
            onMouseDown: function onMouseDown() {
              return _this.itemClick(item);
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-name"
          }, item.employeeName), /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-details"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-id"
          }, item.employeeId), /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-country"
          }, R.prop(extraInfo)(item) || '-'))));
        }))));
      }
      if (_this.state.searchingResults && _this.state.searchValue.length >= 3) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu searching-menu"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "result-details"
        }, _this.props.labels.SEARCHING_LABEL));
      }
      if (_this.state.emptyResults && _this.state.searchValue.length >= 3) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu empty-results-menu"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "result-details"
        }, _this.props.labels.NO_RESULTS_FOUND_LABEL));
      }
      return false;
    });
    _defineProperty(_this, "renderFormula", function (value, description, searchValue, displayName) {
      // if we're searching something and the field already has a
      // value, temporarily show empty
      if (searchValue) return '';
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "formula-value"
      }, displayName || description || R.prop('length', value) > NUMERIC_CUTOFF ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
        id: "tip-".concat(value)
      }), /*#__PURE__*/_react["default"].createElement("span", {
        "data-tip": "".concat(description || value),
        "data-for": "tip-".concat(value),
        "data-place": "bottom",
        "data-offset": "{'bottom': 10}"
      }, displayName || value)) : value);
    });
    _this.state = {
      isNumeric: props.type === 'numeric' || props.type === 'percentage' || props.percentageOnly || props.numericOnly,
      list: [],
      searchValue: '',
      showResultsDropdown: false,
      selectedListIndex: 0,
      searchingResults: false,
      emptyResults: false
    };
    return _this;
  }
  _inherits(Searchable, _React$PureComponent);
  return _createClass(Searchable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        description = _this$props.description,
        error = _this$props.error,
        labels = _this$props.labels,
        displayName = _this$props.displayName,
        disabled = _this$props.disabled,
        id = _this$props.id,
        className = _this$props.className,
        employeeSearchable = _this$props.employeeSearchable,
        searchIcon = _this$props.searchIcon,
        ruleIndex = _this$props.ruleIndex,
        width = _this$props.width,
        keysPath = _this$props.keysPath;
      var _this$state = this.state,
        searchValue = _this$state.searchValue,
        isNumeric = _this$state.isNumeric;
      return /*#__PURE__*/_react["default"].createElement(_SearchableDEPRECATED["default"], {
        disabled: disabled,
        className: className,
        value: value,
        isNumeric: isNumeric,
        employeeSearchable: employeeSearchable,
        searchIcon: searchIcon,
        itemsLength: this.state.list.length,
        error: error,
        width: width,
        isFocused: this.props.isFocused,
        onBlur: this.handleClickOutside
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: id || "rule-".concat(ruleIndex, "-formula-input-").concat(keysPath.join('-')),
        className: "formula-wrapper-label"
      }, this.renderFormula(value, description, searchValue, displayName), !disabled && this.renderSearchableComponent({
        value: value,
        searchValue: searchValue
      }), !employeeSearchable ? this.renderDropdown() : this.renderEmployeesDropdown()), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        message: labels.RULES_BUILDER_VARIABLE_MISSING
      }));
    }
  }]);
}(_react["default"].PureComponent);
Searchable.defaultProps = {
  description: '',
  error: undefined,
  isFocused: false,
  disabled: false,
  placeholder: null,
  id: null,
  percentageOnly: false,
  numericOnly: false,
  value: '',
  displayName: '',
  type: '',
  className: 'searchable-input',
  employeeSearchable: false,
  searchIcon: false,
  extraInfo: 'country',
  width: '',
  regexPattern: '',
  ruleIndex: undefined,
  keysPath: []
};
Searchable.propTypes = {
  percentageOnly: _propTypes["default"].bool,
  numericOnly: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  description: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  displayName: _propTypes["default"].string,
  formulaChange: _propTypes["default"].func.isRequired,
  searchableAction: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  employeeSearchable: _propTypes["default"].bool,
  searchIcon: _propTypes["default"].bool,
  extraInfo: _propTypes["default"].string,
  width: _propTypes["default"].string,
  regexPattern: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]),
  keysPath: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])), _propTypes["default"].number])
};
var _default = exports["default"] = (0, _utils.withDeprecationNotice)(Searchable, 'This Searchable component is deprecated, please use Searchable.jsx');